import React from "react";
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
import {
  AYANA_REWARD_LINK,
  AYANA_JAKARTA_MY_RESERVATION_LINK,
} from "store/constants/link";
import TopBar from "components/TopBar";
import { TopBarItem, NumberBadge } from "components/TopBar";
import MenuToolTipBody from "components/Design/MenuToolTipBody/MenuTooltipBody";
import { MenuToolTipBodyItem } from "components/Design/MenuToolTipBody/MenuTooltipBody";
import { LanguageSelectorMenu } from "components/LanguageSelector";
import ConditionalLink from "components/ConditionalLink";
import Icon from "components/CommonIcon/Icon";
import { embedLanguageInUrl } from "utils/embedLanguageInUrl";
import { JAKARTA } from "store/constants/destinationInBlocks";
import Tooltip from "./Design/Tooltip/Tooltip";
import { getSessionId } from "utils/session";

const AccountMenu = ({ tooltipPosition, hotel }) => {
  const { t } = useTranslation("homepage");
  const { language } = useI18next();

  const myReservationLink =
    hotel === JAKARTA
      ? AYANA_JAKARTA_MY_RESERVATION_LINK
      : `${embedLanguageInUrl(process.env.GATSBY_BOOKING_ENGINE_URL, language, [
          "",
        ])}/find-reservation/`;

  return (
    <Tooltip
      tooltipPosition={tooltipPosition}
      trigger={
        <TopBarItem
          prefixIcon={
            <Icon name="profile" color="text-white" fontSize="text-14" />
          }>
          {t("Account")}
        </TopBarItem>
      }
      openOnHover>
      <div className="text-black capitalize">
        <MenuToolTipBody title={t("Account")}>
          <>
            <MenuToolTipBodyItem
              to={`${embedLanguageInUrl(AYANA_REWARD_LINK, language, [
                "ko",
              ])}/login`}>
              {t("Login to AYANA Rewards")}
            </MenuToolTipBodyItem>
            <MenuToolTipBodyItem
              to={`${embedLanguageInUrl(AYANA_REWARD_LINK, language, [
                "ko",
              ])}/signup`}>
              {t("Join AYANA Rewards")}
            </MenuToolTipBodyItem>
            <MenuToolTipBodyItem to={myReservationLink}>
              {t("My Reservation")}
            </MenuToolTipBodyItem>
          </>
        </MenuToolTipBody>
      </div>
    </Tooltip>
  );
};

export const GuestOptionsBar = ({
  destinationCards,
  hotel,
  cartCount,
  navigationHotel,
  hotelPropertyBali,
}) => {
  const { t } = useTranslation("homepage");
  const { language } = useI18next();

  const bookingEngineLink = `${process.env.GATSBY_BOOKING_ENGINE_URL}${
    language ? `${language}` : ""
  }/cart?sessionId=${getSessionId()}`;

  return (
    <TopBar
      destinationCards={destinationCards}
      navigationHotel={navigationHotel}
      hotelPropertyBali={hotelPropertyBali}>
      <LanguageSelectorMenu />
      <AccountMenu
        tooltipPosition={cartCount > 0 ? "left" : "right"}
        hotel={hotel}
      />
      {cartCount > 0 && (
        <ConditionalLink link={bookingEngineLink || ""} sameTab>
          <TopBarItem suffixIcon={<NumberBadge number={cartCount} />}>
            {t("My cart")}
          </TopBarItem>
        </ConditionalLink>
      )}
    </TopBar>
  );
};
